// src/components/TitleSync.jsx
import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const SITE_NAME = "SLIIT Leo Portal 4.0";

// map exact routes to titles
const TITLES = {
  "/": "Home",
  "/home": "Home",
  "/login": "කුලේ Login",
  "/profile": "Profile",
  "/education": "Leo Education",
  "/tickets": "My Tickets",
  "/club-calander": "Club Calendar",
  "/admin": "Admin Console",
  "/club-projects": "Club Projects",
  "/create-project": "Create Project",
  "/club-dashboard": "Club Dashboard",
  "/reporting-hub": "Reporting Hub",
  "/installation": "Installation",
  "/education-statistics": "Education Admin",
  "/attendance": "Attendance",
  // add other routes here
};

export default function TitleSync() {
  const { pathname } = useLocation();
  const title = TITLES[pathname] || "Leo කුලේ";

  useEffect(() => {
    document.title = `${title} | ${SITE_NAME}`;
  }, [title]);

  return null; // no UI
}
